import React from "react";
import modalStyles from "@/styles/Modal.module.scss";
import formStyles from "@/styles/Form.module.scss";
import { Button } from "../Buttons";
import { useEffect, useRef } from "react";
import { TextField } from "../Form/Parts";
import { useForm } from "react-hook-form";
import * as y from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import yupNickNameValidate from "@/lib/yupNickNameValidate";
import classnames from "classnames";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
yupNickNameValidate(y);
const schema = y.object().shape({
  nickName: y.string().nickName("ニックネーム").min(2, "ニックネームは2文字以上、20文字以内で入力してください。").max(20, "ニックネームは2文字以上、20文字以内で入力してください。").required("ニックネームが入力されていません。")
});
const NickNameInputModal = _ref => {
  var _errors$nickName;
  let {
    handleClick,
    modalCloseHandle
  } = _ref;
  const {
    formState,
    register,
    handleSubmit,
    errors
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all"
  });
  const {
    isValid,
    isSubmitting
  } = formState;
  const nickNameRef = useRef(null);
  useEffect(() => {
    if (nickNameRef.current) nickNameRef.current.focus();
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      className: modalStyles.container,
      children: [/*#__PURE__*/_jsxs("form", {
        onSubmit: handleSubmit(handleClick),
        noValidate: true,
        children: [/*#__PURE__*/_jsx("header", {
          children: /*#__PURE__*/_jsx("h2", {
            children: "\u30CB\u30C3\u30AF\u30CD\u30FC\u30E0\u306E\u8A2D\u5B9A"
          })
        }), /*#__PURE__*/_jsx("p", {
          className: modalStyles.guideLineText,
          children: "\u30C1\u30E3\u30C3\u30C8\u6642\u306E\u30CB\u30C3\u30AF\u30CD\u30FC\u30E0\u3092\u8A2D\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
        }), /*#__PURE__*/_jsx("fieldset", {
          className: formStyles.basicFieldset,
          children: /*#__PURE__*/_jsx(TextField, {
            ref: e => {
              register(e);
              nickNameRef.current = e;
            },
            className: classnames(modalStyles.nickNameInput, {
              [modalStyles.isError]: !isValid
            }),
            title: "\u30CB\u30C3\u30AF\u30CD\u30FC\u30E0",
            type: "text",
            name: "nickName",
            defaultValue: "",
            placeholder: "2\u6587\u5B57\u4EE5\u4E0A20\u6587\u5B57\u4EE5\u5185\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
            error: (_errors$nickName = errors.nickName) === null || _errors$nickName === void 0 ? void 0 : _errors$nickName.message,
            required: true
          })
        }), /*#__PURE__*/_jsx(Button, {
          type: "button",
          onClick: handleSubmit(handleClick),
          fillWhiteColor: true,
          fontFixed: true,
          large: true,
          disabled: !isValid,
          disabledWithGray: true,
          loading: isSubmitting,
          children: "\u78BA\u5B9A"
        })]
      }), /*#__PURE__*/_jsx(Button, {
        type: "button",
        fontFixed: true,
        large: true,
        borderLight: true,
        onClick: modalCloseHandle,
        children: "\u9589\u3058\u308B"
      })]
    })
  });
};
export default NickNameInputModal;